module.exports = __webpack_public_path__ + "img/img_6.894a4956.png";